"use client";

import styled from "styled-components";
import { PageWrapper } from "./globalsStyles";

export const LoginPageWrapper = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5rem;
  gap: 2rem;
`;
